import { type FC } from "react";

import { lazyWithRetry } from "helpers/lazy-with-retry";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const PrivacyPolicy = lazyWithRetry(() => import("routes/privacy-policy/PrivacyPolicy"));
const Tutorial = lazyWithRetry(() => import("routes/tutorial/Tutorial"));
const ExportReport = lazyWithRetry(() => import("routes/export-report/ExportReport"));
const AppProviders = lazyWithRetry(() => import("./AppProviders"));

export const GlobalRouter: FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="privacy-policy" element={<PrivacyPolicy />} />
      <Route path="tutorial" element={<Tutorial />} />
      <Route path="export-report" element={<ExportReport />} />
      <Route path="*" element={<AppProviders />} />
    </Routes>
  </BrowserRouter>
);
